export default __webpack_public_path__ + "static/media/mintsite_graphic_6.fe7bb4be.png";